import FeaturedMatchesWidgetContainer from './containers/FeaturedMatchesWidgetContainer';
import React from 'react';
import { Provider } from 'react-redux';
import { reduxBatch } from '@manaflair/redux-batch';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import PropTypes from 'prop-types';
import thunk from 'redux-thunk';
import CommonDataListEventsReducer from '../CommonDataListEvents/reducers/commonDataListEventsReducers';

class FeaturedMatchesWidget extends React.Component {

    static propTypes = {
        sport: PropTypes.string.isRequired,
    }

    constructor(props) {
        super(props);
        const composeEnhancers = composeWithDevTools({
            name: `FeaturedMatchesWidget [${props.sport}]`,
        });

        this.store = createStore(
            CommonDataListEventsReducer,
            {},
            composeEnhancers(
                applyMiddleware(thunk),
                reduxBatch
            )
        );
    }

    render() {

        return (
            <Provider store={this.store}>
                <FeaturedMatchesWidgetContainer {...this.props} />
            </Provider>
        );
    }
}

export default FeaturedMatchesWidget;
